import Pqp from "../../3x1010/Pqp.js";
import Screen from "../screen/Screen.js";
import Skills from "../screen/skills/Skills.js";
import Bout from "./Bout.js";

export default class Player {
	constructor(values) {
		for (let prop in values) {
			this[prop] = values[prop];
		}
		this.skills = JSON.parse(JSON.stringify(this.skills));
		this.skills_check = JSON.parse(JSON.stringify(this.skills_check));
		this.consumingf = 0;
		this.consumingw = 0;
	}

	addCoin(item) {
		this.coin += item.getStackQuantity();
	}

	get currentLevel() {
		let a = Player.XP_LEVELS;
		for (let x = 0; x < a.length; x++) {
			if (this.xp < a[x]) {
				this.level = x + 1
				return x + 1;
			}
		}
		this.level = 100;
		return 100;
	}

	get xpNextLevel() {
		let a = Player.XP_LEVELS;
		for (let x = 0; x < a.length; x++) {
			if (this.xp < a[x]) {
				return a[x];
			}
		}
		return -1;
	}

	getSkillValue(id) {
		let o = this.skills;
		// Controlla i bonus
		let bonuses = Bout.that.getSkillsBonuses()
		let bonus = 0;
		if (bonuses[id]) {
			//console.log(id)
			bonus = bonuses[id]
		}

		return o[id] + bonus;
	}

	getPlainSkillValue(id) {
		let o = this.skills;
		return o[id]
	}

	static checkSkill(id, lFight = false) {

		let player = Bout.that.player;
		//console.log(id,player.skills[id])
		let prob = (1000 - player.skills[id]) / 1000;


		let lastCheck = player.skills_check[id];
		let dif = 0
		if (lastCheck > 0) {
			let time = (new Date()).getTime();
			dif = Math.floor(Math.floor((time - lastCheck) / 1000) / 60);
			prob += dif / 1000;
		}
		//console.log(prob, dif / 1000)
		player.skills_check[id] = (new Date()).getTime();

		if (Pqp.check(prob)) {
			let inc = Player.getIncrementSkill(player.skills[id]);
			player.skills[id] = player.skills[id] + inc;
			Screen.that.showSkillGain(id, player.skills[id], inc, lFight);
		}

	}

	static getIncrementSkill(value) {
		let choice;
		if (value < 100) {
			choice = [3, 4, 5];
		} else if (value < 150) {
			choice = [2, 3, 4];
		} else if (value < 200) {
			choice = [1, 2, 3];
		} else if (value < 300) {
			choice = [1, 2];
		} else {
			choice = [1];
		}
		return choice[Pqp.rnd(choice.length - 1)];
	}


	consumeWaterAndFood() {
		this.consumingf++;
		this.consumingw++;
		if (this.consumingf === Player.CONSUME_FOOD_EVERY) {
			this.consumingf = 0;
			this.food--;
			//console.log("consumo f")
			if (this.food < 0) {
				this.food = 0;
			}
		}
		if (this.consumingw === Player.CONSUME_WATER_EVERY) {
			this.consumingw = 0;
			this.water--;
			if (this.water < 0) {
				this.water = 0;
			}
		}
	}

	isDead() {
		//this.hp = 0
		if (this.hp === 0) {
			return true;
		}
		return false;
	}

	incrementXp(xp) {
		let level = this.currentLevel;
		this.xp += xp;
		if (this.currentLevel !== level) {
			return this.levelUp();
		}
		return null;
	}



	isHungry() {
		return this.food < Player.PLAYER_HUNGRY ? true : false;
	}

	isThirsty() {
		return this.water < Player.PLAYER_THIRSTY ? true : false;
	}

	isPoisoned() {
		return this.poisoned;
	}
	isBleeding() {
		return this.bleeding;
	}


	checkHeroHitsSkill() {
		let item = Screen.that.paperdoll.getCurrentWeapon();
		if (item) {
			if (Pqp.check(0.75)) {
				Player.checkSkill(item.weapon_skill, true);
			} else {
				Player.checkSkill(Skills.SKILL_ARMSLORE, true);
			}
		} else {
			Player.checkSkill(Skills.SKILL_ARMSLORE, true);
		}
	}

	checkHeroMissesSkill() {
		if (Pqp.check(0.2)) {
			this.checkHeroHitsSkill();
		}

	}

	checkEnemyParriedSkill() {
		if (Pqp.check(0.5)) {
			this.checkHeroHitsSkill();
		}
	}

	checkEnemyHitsSkill() {
		Player.checkSkill(Skills.SKILL_ARMOURPROFICIENCY, true);
	}

	checkEnemyMissesSkill() {
		if (Pqp.check(0.5)) {
			Player.checkSkill(Skills.SKILL_TACTICS, true);
		}
	}

	checkHeroParriedSkill() {
		Player.checkSkill(Skills.SKILL_PARRYING, true);
	}

	levelUp() {
		//console.log("TO DO - LEVEL UP!")
		let ret = ""
		this.max_hp += 5;
		ret = " gets 5 hit points and ";
		if (this.currentLevel % 10 === 0) {
			this.base_speed += 1;
			ret += " 1 base speed point!"
		} else {
			let n = this.currentLevel % 3;
			if (n === 0) {
				this.max_weight += 20;
				ret += " you can carry 2Kg more!"
			} else if (n === 1) {
				this.base_damage += 1;
				ret += " 1 base damage point!"
			} else if (n === 2) {
				this.base_armour += 1;
				ret += " 1 base armour point!"
			}
		}
		return ret;

	}

	restHeal() {
		let diff = Math.floor((this.max_hp - this.hp)/2);
		this.hp = this.max_hp;
		this.food -= diff;
		this.water -= diff;
	}

	isFullyHealed() {
		if (this.max_hp === this.hp) {
			return true;
		}
		return false;
	}


}

Player.CONSUME_FOOD_EVERY = 1000;
Player.CONSUME_WATER_EVERY = 750;


Player.STARTING_STATS = {
	hp: 100,
	max_hp: 100,
	food: 100,
	max_food: 100,
	water: 100,
	max_water: 100,
	coin: 0,
	max_weight: 500,
	level: 0,
	xp: 0,
	base_damage: 4,
	base_armour: 0,
	base_speed: 2,
	poisoned: false,
	bleeding: false,
	skills: {
		ArmsLore: 0,
		Swordsmanship: 0,
		Fencing: 0,
		MaceCombat: 0,
		Tactics: 0,
		ArmourProficiency: 0,
		Parrying: 0,
		Mining: 0,
		Cooking: 0,
		Camping: 0,
		RemoveTrap: 0,
		Fishing: 0,
		Alchemy: 0,
		Lumberjack: 0
	},
	skills_check: {
		ArmsLore: 0,
		Swordsmanship: 0,
		Fencing: 0,
		MaceCombat: 0,
		Tactics: 0,
		ArmourProficiency: 0,
		Parrying: 0,
		Mining: 0,
		Cooking: 0,
		Camping: 0,
		RemoveTrap: 0,
		Fishing: 0,
		Alchemy: 0,
		Lumberjack: 0
	}
}

Player.XP_LEVELS = [
	83,
	174,
	276,
	388,
	512,
	650,
	801,
	969,
	1154,
	1358,
	1584,
	1833,
	2107,
	2411,
	2746,
	3115,
	3523,
	3973,
	4470,
	5018,
	5624,
	6291,
	7028,
	7842,
	8740,
	9730,
	10824,
	12031,
	13363,
	14833,
	16456,
	18247,
	20224,
	22406,
	24815,
	27473,
	30408,
	33648,
	37224,
	41171,
	45529,
	50339,
	55649,
	61512,
	67983,
	75127,
	83014,
	91721,
	101333,
	111945,
	123660,
	136594,
	150872,
	166636,
	184040,
	203254,
	224466,
	247886,
	273742,
	302288,
	333804,
	368599,
	407015,
	449428,
	496254,
	547953,
	605032,
	668051,
	737627,
	814445,
	899257,
	992895,
	1096278,
	1210421,
	1336443,
	1475581,
	1629200,
	1798808,
	1986068,
	2192818,
	2421087,
	2673114,
	2951373,
	3258594,
	3597792,
	3972294,
	4385776,
	4842295,
	5346332,
	5902831,
	6517253,
	7195629,
	7944614,
	8771558,
	9684577,
	10692629,
	11805606,
	13034431
];


Player.PLAYER_HUNGRY = 20;
Player.PLAYER_THIRSTY = 20;